import Loadable from 'components/Loadable';

const landing = {
  exact: true,
  path: '/',
  component: Loadable({
    loader: () => import(/* webpackPrefetch: true */ '../views/landing'),
  }),
};

export default landing;
